import React from 'react';
import styled from 'astroturf/react';

const Container = styled.div<{ blue?: boolean }>`
  border: 4px solid #d9d9d9;
  border-left-color: #91919e;
  border-radius: 50%;
  animation: spin 1s infinite linear;
  display: inline-block;

  &.blue {
    border: 8px solid #cddaef;
    border-left-color: #386ac1;
  }

  @keyframes spin {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export type SpinnerProps = {
  size?: number;
  blue?: boolean;
};

export const Spinner: React.FC<SpinnerProps> = ({ size = 28, blue }) => {
  return <Container blue={blue} style={{ width: size, height: size }} />;
};
